import React, { useState } from "react";
import Layout from "../components/Layout";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

import "../assets/css/Loginpage.scss";
import { toast } from "react-toastify";

const Loginpage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const auth = getAuth();
  const navigate = useNavigate();

  const login = async () => {
    try {
      setLoading(true);
      const result = await signInWithEmailAndPassword(auth, email, password);
      localStorage.setItem("currentUser", JSON.stringify(result));
      setLoading(false);
      toast.success("Login Success");
      navigate("/");
    } catch (error) {
      setLoading(false);
      toast.error("Login Failed");
    }
  };

  return (
    <Layout>
      <div className="login_container col-md-6">
        <div className="login_section">
          <h4>Login</h4>
          <hr />
          <input
            type="text"
            className="form-control input_field"
            placeholder="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <input
            type="password"
            className="form-control input_field"
            placeholder="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
          <div className="login_button_section">
            <button className="btn btn-success" onClick={login}>
              Login
            </button>
            <Link to="/register">New to Deltafoods? Create an account</Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Loginpage;
